
<div class="container" >
    <px-m0220-image-gallery [images]="content"></px-m0220-image-gallery>
</div>
